import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import { getCsrfTokenCached } from "@/auth/csrf";
import { router } from "@/router";
import "@/styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

// Warm the CSRF cache so the first state-changing request out of the
// SPA doesn't pay an extra round-trip.
void getCsrfTokenCached();

const container = document.getElementById("root");
if (!container) throw new Error("missing #root element in index.html");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
